import { defineComponent as _defineComponent } from 'vue'
import HeaderCustomer from "@/components/HeaderCustomer.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerLayoutWithNav',
  setup(__props, { expose: __expose }) {
  __expose();

  
const __returned__ = { HeaderCustomer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})